<template>
  <v-card
    border
    tile
  >
    <StaticMap
      v-if="!provider.hide_address"
      :height="250"
      :hide-address="provider.hide_address"
      :latitude="provider.latitude"
      :longitude="provider.longitude"
      :width="382"
    />

    <v-card-title class="fs-20 fw-800">
      {{ $bct('Contact information') }}
    </v-card-title>

    <v-card-text class="fs-16 fw-400">
      <ListItem
        :text="providerAddressDisplay"
        data-testid="provider-contact-address"
        icon="location_on"
        no-translate
      />

      <ListItem
        v-if="display.smAndDown"
        :href="'tel:' + provider.phone"
        :text="provider.phone || $bct('Phone not available')"
        icon="phone"
        no-translate
      />
      <ListItem
        v-else
        :text="provider.phone || $bct('Phone not available')"
        icon="phone"
        no-translate
      />

      <ListItem
        :text="provider.email || $bct('Email not available')"
        icon="mail_outline"
        no-translate
      />

      <ListItem
        :href="provider.website"
        :text="provider.website || $bct('No website')"
        icon="laptop_chromebook"
        no-translate
      />

      <v-row v-if="provider.google_url || provider.facebook_url || provider.yelp_url">
        <v-col>
          <a
            v-if="provider.google_url"
            :href="provider.google_url"
            class="me-4"
            target="_blank"
          >
            <img
              :alt="$bct('Google')"
              :src="$a.url('icons.google_round')"
              class="h-24"
            />
          </a>

          <a
            v-if="provider.facebook_url"
            :href="provider.facebook_url"
            class="me-4"
            target="_blank"
          >
            <img
              :alt="$bct('Facebook')"
              :src="$a.url('icons.facebook_round')"
              class="h-24"
            />
          </a>

          <a
            v-if="provider.yelp_url"
            :href="provider.yelp_url"
            target="_blank"
          >
            <img
              :alt="$bct('Yelp')"
              :src="$a.url('icons.yelp_round')"
              class="h-24"
            />
          </a>
        </v-col>
      </v-row>

      <v-row
        v-for="(field, index) in $store.state.schemas[provider.schema_id].meta.contact.append"
        :key="index"
      >
        <CustomField
          :field="field"
          :model-value="provider"
          :readonly="true"
          :schema-id="provider.schema_id"
          :show-title="false"
          class="fs-16"
          mode="show"
          show-icon="true"
        />
      </v-row>

      <div
        v-if="provider.contact_name || provider.contact_email"
        class="c-black fw-600 fs-18 mb-2 mt-4"
      >
        {{ $bct('Primary contact') }}
      </div>

      <ListItem
        v-if="provider.contact_name"
        :text="provider.contact_name"
        icon="person_pin"
        no-translate
      />

      <ListItem
        v-if="provider.contact_phone"
        :text="provider.contact_phone"
        icon="phone"
        no-translate
      />

      <ListItem
        v-if="provider.contact_email"
        :text="provider.contact_email"
        icon="mail_outline"
        no-translate
      />
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useDisplay } from 'vuetify';

import CustomField from '@/shared/components/CustomField.vue';
import { formatAddress } from '@/shared/services/address';
import ListItem from '@/shared/components/ListItem.vue';
import StaticMap from '@/shared/components/provider/StaticMap.vue';

const props = defineProps({
  provider: {
    type: Object,
    default: null,
  },
});

const display = useDisplay();
const $bct = inject('translator');

const providerAddressDisplay = computed(() => {
  if (!props.provider) return null;

  return formatAddress(props.provider.address1, props.provider.city);
});
</script>
